import React from 'react';

function CheckIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        d="M5.86675 11.3L3.30245 8.73569C3.17227 8.60551 2.96122 8.60551 2.83104 8.73569L2.36912 9.19762C2.23894 9.32779 2.23894 9.53884 2.36912 9.66902L5.63104 12.9309C5.76122 13.0611 5.97227 13.0611 6.10245 12.9309L13.631 5.40235C13.7612 5.27218 13.7612 5.06112 13.631 4.93095L13.1691 4.46902C13.0389 4.33884 12.8279 4.33884 12.6977 4.46902L5.86675 11.3Z"
        fill="#13BC86"
      />
    </svg>
  );
}

export default CheckIcon;
